import { useContext } from "react";
import { GlobalContext } from "../../context/GlobalContext";

export const useModal = () => useContext(GlobalContext).modal;